<template>
  <div class="store-selection">
    <v-card
      max-width="400"
      min-width="400"
      class="mx-auto">
      <v-card-title>Connect with tiktok shop</v-card-title>
      <v-card-text>
        <div><strong>App Key : </strong> {{ info.appKey }}</div>
        <div><strong>Code : </strong> {{ info.code }}</div>
        <div><strong>Locale : </strong> {{ info.locale }}</div>
        <div><strong>Shop Region : </strong> {{ info.shopRegion }}</div>
      </v-card-text>
      <v-card-text>
        <v-select
          v-model="store"
          :items="storeOptions"
          item-text="name"
          return-object
          label="Store"
          outlined
          dense
          @change="onStoreChange"
        />

        <v-select
          v-model="brand"
          :items="filteredBrands"
          item-text="name"
          item-value="name"
          label="Brand"
          outlined
          dense
          :disabled="!store"
        />

        <v-btn
          color="primary"
          block
          :loading="loading"
          :disabled="info.code === '' || store === null || brand === null"
          @click="submit">
          Connect
        </v-btn>
        <div
          v-if="info.code === ''"
          class="error-text text-center mt-2">
          The code is missing.
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TiktokProvider from '@/resources/TiktokProvider'

const TiktokService = new TiktokProvider()
export default {
  data () {
    return {
      store: null,
      brand: null,
      loading: false,
      info: {
        appKey: '',
        code: '',
        locale: '',
        shopRegion: ''
      },
      storeOptions: [
        {
          id: '5e3548c2d32cb12606a34fb8',
          name: 'Gentlewoman'
        },
        {
          id: '645a1d00765d5519beeb97f6',
          name: 'Matter Makers'
        }
      ],
      brandOptions: [
        {
          name: 'Test Gentlewoman',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          uniqueCode: 'GW',
          id: 1,
          testOnly: true
        },
        {
          name: 'Gentlewoman',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          uniqueCode: 'GW',
          id: 1
        },
        {
          name: 'Gentlelittlewoman',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          uniqueCode: 'LW',
          id: 2
        },
        {
          store: {
            id: '645a1d00765d5519beeb97f6',
            name: 'Matter Makers'
          },
          name: 'Matter Makers',
          uniqueCode: 'MM',
          id: 3
        },
        {
          name: 'Gentlewoman Universe',
          uniqueCode: 'GU',
          store: {
            id: '5e3548c2d32cb12606a34fb8',
            name: 'gentlewoman'
          },
          id: 4
        }
      ]
    }
  },
  computed: {
    filteredBrands () {
      if (!this.store) return []
      const isProduction = process.env.VUE_APP_MODE === 'Production'
      return this.brandOptions.filter((brand) => {
        if (isProduction && brand.testOnly) return false
        return brand.store.id === this.store.id
      })
    }
  },
  mounted () {
    const { code, locale, shopRegion, appKey } = this.$route.query
    if (code) {
      this.info.code = code
      this.info.locale = locale
      this.info.shopRegion = shopRegion
      this.info.appKey = appKey
    } else {
      this.$store.dispatch('Components/setSnackbar', {
        value: true,
        message: 'Error code not found',
        type: 'error'
      })
    }
  },
  methods: {
    onStoreChange () {
      this.brand = ''
    },
    async submit () {
      const payload = {
        code: this.info.code,
        store: this.store,
        brand: this.brand
      }

      try {
        this.loading = true
        const { data } = await TiktokService.connectShop(payload)
        if (data) {
          this.$store.dispatch('Components/setSnackbar', {
            value: true,
            message: 'Connected',
            type: 'success'
          })
          this.$router.push({ name: 'Home' })
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.store-selection {
  padding: 20px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  min-height: 100dvh;
}
.error-text {
  color: red;
  font-size: 14px;
}
</style>
